import React from "react";
import { Account } from "./components/Account";
export const App: React.FC = () => {
  return <Account></Account>;
};
